module.exports = __webpack_public_path__ + "static/EU-480x480-a181161feda549478d9db9888012c07f.png";